import React, { useState, useEffect } from "react";
import "./dashboard.css";
import Chart from "react-apexcharts";
import { Fade } from "react-awesome-reveal";
import request from "../../shared/utils/request";
import { Loader } from "../../shared/components/loader";

const Services = () => {
  const [loading, setLoading] = useState(false);
  const [countDatas, setCountDatas] = useState([]);
  const [chartDatas, setChartDatas] = useState({
    options: {
      chart: {
        id: "basic-bar",
      },
      xaxis: {
        categories: [],
      },
    },
    series: [
      {
        name: "series-1",
        data: [],
      },
    ],
  });

  useEffect(() => {
    getDatas();
    getDashboardChart();
  }, []);

  const getDatas = async () => {
    try {
      setLoading(true);
      const response = await request.get("student/getDashboardCounts");
      if (response?.data?.success) {
        setCountDatas(response?.data?.data);
      }
    } catch (error) {
      console.error("Error fetching  data:", error);
    } finally {
      setLoading(false); // Step 3: Set loading to false after the request is completed
    }
  };

  const getDashboardChart = async () => {
    try {
      setLoading(true);
      const response = await request.get(
        "student/getGrammarBookSubmitStatistics"
      );
      if (response?.data?.status) {
        const data = response?.data?.data;
        const categories = data.map(item => item.date);
        const series = data.map(item => item.count);
        setChartDatas({
          options: {
            chart: {
              id: "basic-bar",
            },
            xaxis: {
              categories,
            },
          },
          series: [
            {
              name: "series-1",
              data: series,
            },
          ],
        });
      }
    } catch (error) {
      console.error("Error fetching  data:", error);
    } finally {
      setLoading(false); // Step 3: Set loading to false after the request is completed
    }
  };

  const checkCourseType =
    localStorage.getItem("courseType") === "Non-Test Based";

  return (
    <section id="services" className="services section">
      {/* Section Title */}
      <Fade>
        <div className="container section-title">
          <h2>Dashboard</h2>
        </div>
      </Fade>

      {/* End Section Title */}

      <div className="container student-dashboard">
        <div className="row gy-4">
          <div className="container-fluid px-4 py-4">
            <Loader isLoading={loading} />
            <div className="row mb-4">
              <div
                className={`${
                  checkCourseType ? "col-md-3" : "col-md-4"
                } col-sm-6`}
              >
                <div
                  className="stat-card text-center p-4"
                  style={{
                    background: "linear-gradient(135deg, #4e73df, #224abe)",
                    color: "white",
                  }}
                  data-aos="fade-up"
                > 
                  <div className="card-icon mx-auto">
                    <i className="fas fa-book" />
                  </div>
                  <h2 className="display-4 fw-bold mb-1">{countDatas?.total_readtogether}</h2>
                  <p className="mb-0 text-white-50">My Library</p>
                </div>
              </div>
              <div
                className={`${
                  checkCourseType ? "col-md-3" : "col-md-4"
                } col-sm-6`}
              >
                <div
                  className="stat-card text-center p-4"
                  style={{
                    background: "linear-gradient(135deg, #1cc88a, #13855c)",
                    color: "white",
                  }}
                >
                  <div className="card-icon mx-auto">
                    <i className="fas fa-tasks" />
                  </div>
                  <h2 className="display-4 fw-bold mb-1">
                    {countDatas?.vocabularies}
                  </h2>
                  <p className="mb-0 text-white-50">My Notebook</p>
                </div>
              </div>
              <div
                className={`${
                  checkCourseType ? "col-md-3" : "col-md-4"
                } col-sm-6`}
              >
                <div
                  className="stat-card text-center p-4"
                  style={{
                    background: "linear-gradient(135deg, #36b9cc, #258391)",
                    color: "white",
                  }}
                >
                  <div className="card-icon mx-auto">
                    <i className="fas fa-chart-line" />
                  </div>
                  <h2 className="display-4 fw-bold mb-1">
                    {countDatas?.vocabularies_pending}
                  </h2>
                  <p className="mb-0 text-white-50">Pending Notebooks</p>
                </div>
              </div>
              {checkCourseType && (
                <div className="col-md-3 col-sm-6">
                  <div
                    className="stat-card text-center p-4"
                    style={{
                      background: "linear-gradient(135deg, #f6c23e, #dda20a)",
                      color: "white",
                    }}
                  >
                    <div className="card-icon mx-auto">
                      <i className="fas fa-calendar-check" />
                    </div>
                    <h2 className="display-4 fw-bold mb-1">
                      {countDatas?.grammar_book_pending_answer}
                    </h2>
                    <p className="mb-0 text-white-50">Pending Grammar Book</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {checkCourseType && (
          <div className="row">
            <div className="col-lg-7">
              <Chart
                options={chartDatas.options}
                series={chartDatas.series}
                type="line"
                width="100%"
              />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Services;
